import styled from 'styled-components';

export const BreadrumbsWrapper = styled.div`
  padding: 4.25rem 3.75rem 3.125rem;
  @media (min-width: 769px) and (max-width: 992px) {
    padding: 4.25rem 1.875rem 3.125rem;
  }
  @media (max-width: 768px) {
    padding: 1.75rem 1rem;
  }
  ol {
    max-width: 80rem;
    list-style: none;
    padding: 0;
    margin: 0 auto;
    display: flex;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    .active-crumb {
      pointer-events: none;
    }
    li {
      font-weight: 400;
      font-size: 0.875rem;
      margin-right: 0.75rem;
      line-height: 1rem;
      display: flex;
      &:last-child {
        pointer-events: none;
      }
      & a:hover {
        transform: scale(1.1);
      }
      svg {
        display: block;
        margin-right: 0.75rem;
      }
    }
  }
`;
